import { IgAlert } from "@intelligems/ig-theme/IgAlert";
import { IgLink } from "@intelligems/ig-theme/IgLink";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { ExperienceCategory } from "@intelligems/ig-types/dtos/experience-categories";
import { officialCategoryName } from "@intelligems/ig-utils/common";
import {
  endingThemePersonalization,
  endingThemeTest,
} from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

import {
  ThemeWarningContext,
  themeWarningDescription,
  themeWarningTitle,
} from "./copy";

interface ThemeExperienceWarningBannerProps {
  category: ExperienceCategory;
  context: ThemeWarningContext;
  /** Resolved via `useThemeExperienceThemeNames`; `[]` falls back to generic copy. */
  themeNames: string[];
}

export const ThemeExperienceWarningBanner = ({
  category,
  context,
  themeNames,
}: ThemeExperienceWarningBannerProps) => {
  const link =
    category === "personalization"
      ? endingThemePersonalization
      : endingThemeTest;

  return (
    <IgAlert
      alertKey={`theme-${category}-warning-banner`}
      severity="warning"
      title={themeWarningTitle(context, category, themeNames)}
      message={
        <IgTypography>
          {themeWarningDescription(context, category)}{" "}
          <IgLink
            onClick={() =>
              openNewTab(
                link,
                `Ending a Theme ${officialCategoryName(category, true)}`
              )
            }
          >
            Learn more.
          </IgLink>
        </IgTypography>
      }
    />
  );
};
